import { useDispatch, useSelector } from "react-redux";
import { basics, baseURL } from "../../../basics";
import GradeDescription from "../../Ui/GradeDescription";
import UnitTypeBox from "../../Ui/UnitTypeBox";
import ShowPriceInCardItem from "../ListOfProducts/ShowPriceInCardItem";
import CheckStockAndChangeButton from "../../Ui/CheckStockAndChangeButton";
import { cartActions } from "../../../store/cart-slice";
import { BsX } from "react-icons/bs";

const ListOfCartItemsInCartInProfile = () => {
  const dispatch = useDispatch();
  const cartItems = useSelector((state: any) => state.cart.items.items);
  const eraseItemHandler = (id: any) => {
    dispatch(cartActions.eraseItemFromCart(id));
  };
  return (
    <div className="space-y-2.5">
      {cartItems.map((item: any) => {
        const unitPrice = item.product.discountedPrice ?? item.product.price;
        const lineTotal = unitPrice * item.quantity;
        return (
          <div
            key={item.product.id}
            className="relative flex items-center gap-3 rounded-xl border border-slate-100 bg-white p-3 shadow-sm transition hover:shadow-md"
          >
            <img
              src={`${baseURL}${item.product.imageUrl}`}
              alt={item.product.title}
              className="h-16 w-16 shrink-0 rounded-lg bg-white object-contain p-1.5 ring-1 ring-black/5 sm:h-24 sm:w-24"
            />
            <button
              onClick={() => eraseItemHandler(item.product.id)}
              className="absolute left-2 top-2 flex h-6 w-6 items-center justify-center rounded-full text-slate-400 transition hover:bg-rose-50 hover:text-rose-600"
            >
              <BsX className="h-5 w-5" />
            </button>

            <div className="min-w-0 flex-1">
              <p className="truncate pr-4 text-sm font-bold text-gray-900 sm:text-base">
                {item.product.title}
              </p>
              <div className="mt-1 flex flex-wrap items-center gap-1.5">
                <GradeDescription
                  grade={item.product.grade}
                  color={"black"}
                  align="right"
                />
                <UnitTypeBox
                  unit={item.product.unit}
                  unitType={item.product.unitType}
                />
              </div>
              <div className="mt-1.5 w-fit">
                <ShowPriceInCardItem
                  price={item.product.price}
                  discountedPrice={item.product.discountedPrice}
                />
              </div>
            </div>
            <div className="flex w-32 shrink-0 flex-col items-center gap-1.5 pt-4">
              <p className="text-xs font-bold text-gray-500">{`${lineTotal.toLocaleString()} ${
                basics.priceName
              }`}</p>
              <CheckStockAndChangeButton
                items={item.product}
                parentStyles="w-full"
                childStyles={"bg-orange-500 hover:bg-orange-600 shadow-sm"}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ListOfCartItemsInCartInProfile;
